export class Company {
    company_id ? = '';
    company_name ? = '';
    contact_person ? = '';
    designation ? = '';
    landline ? = '';
    mobile ? = '';
    email ? = '';
    website ? = '';
    location ? = '';
    description ? = '';
    additional_info ? = '';
    company_status_id ? = '';
    category ? = '';
    company_quota ? = '';
    priority_level ? = '';
    last_contacted_at ? = '';
    last_contacted_by ? = '';
    company_status ? = '';
    user_id ? = '';
    company_status_class ? = '';
    last_contacted_by_firstname ? = '';
    last_contacted_by_lastname ? = '';
    due_date ? = '';
    created_at ? = '';
    updated_at ? = '';
    approved_status ? = '';
}


// WEBPACK FOOTER //
// ./src/app/type/company.ts